import React from "react";
import { useSelector } from "react-redux";

export function Radio({ isSelected, onChange, children, label, id, name, disabled }) {
  const { language } = useSelector((state) => state.auth);
  return (
    <>
      <div className={`custom-control custom-radio ${language === "arabic" && "arabic-layout"}  `}>
        <input className="custom-control-input " id={id} type="radio" checked={isSelected} onChange={onChange} name={name} disabled={disabled} />
        {label && (
          <label htmlFor={id} className="custom-control-label">
            <b>{label}</b>
          </label>
        )}
        {children}
      </div>
    </>
  );
}
